import { ProdutoTable } from "../../../types/Produto";

// Tipos de ordenação
export type OrdenacaoProduto =
  | 'referencia-asc' | 'referencia-desc'
  | 'nome-asc' | 'nome-desc'
  | 'categoria-asc' | 'categoria-desc'
  | null;

export type OrdenacaoVariacao =
  | 'variacao-asc' | 'variacao-desc'
  | 'preco-asc' | 'preco-desc'
  | null;

export interface OrdenacaoConfig {
  produto: OrdenacaoProduto;
  variacao: OrdenacaoVariacao;
}

// Opções para os chips
export const opcoesProduto: { label: string; value: OrdenacaoProduto }[] = [
  { label: 'SKU A-Z', value: 'referencia-asc' },
  { label: 'SKU Z-A', value: 'referencia-desc' },
  { label: 'Nome A-Z', value: 'nome-asc' },
  { label: 'Nome Z-A', value: 'nome-desc' },
  { label: 'Categoria A-Z', value: 'categoria-asc' },
  { label: 'Categoria Z-A', value: 'categoria-desc' },
];

export const opcoesVariacao: { label: string; value: OrdenacaoVariacao }[] = [
  { label: 'Variação A-Z', value: 'variacao-asc' },
  { label: 'Variação Z-A', value: 'variacao-desc' },
  { label: 'Maior Valor', value: 'preco-desc' },
  { label: 'Menor Valor', value: 'preco-asc' },
];

// Chave do localStorage
const STORAGE_KEY = 'tableProdutos_ordenacao';

// Funções de persistência
export const salvarOrdenacao = (ordenacao: OrdenacaoConfig): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ordenacao));
};

export const carregarOrdenacao = (): OrdenacaoConfig => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch {
      return { produto: null, variacao: null };
    }
  }
  return { produto: null, variacao: null };
};

// Tipo da variação (extraído do ProdutoTable)
type Variacao = NonNullable<ProdutoTable['variacoes']>[number];

// Função para ordenar produtos
export const ordenarProdutos = (
  produtos: ProdutoTable[],
  ordenacao: OrdenacaoProduto
): ProdutoTable[] => {
  if (!ordenacao) return produtos;

  const produtosCopia = [...produtos];

  switch (ordenacao) {
    case 'referencia-asc':
      return produtosCopia.sort((a, b) =>
        (a.referencia ?? '').localeCompare(b.referencia ?? '')
      );
    case 'referencia-desc':
      return produtosCopia.sort((a, b) =>
        (b.referencia ?? '').localeCompare(a.referencia ?? '')
      );
    case 'nome-asc':
      return produtosCopia.sort((a, b) =>
        (a.nome ?? '').localeCompare(b.nome ?? '')
      );
    case 'nome-desc':
      return produtosCopia.sort((a, b) =>
        (b.nome ?? '').localeCompare(a.nome ?? '')
      );
    case 'categoria-asc':
      return produtosCopia.sort((a, b) =>
        (a.categoria ?? '').localeCompare(b.categoria ?? '')
      );
    case 'categoria-desc':
      return produtosCopia.sort((a, b) =>
        (b.categoria ?? '').localeCompare(a.categoria ?? '')
      );
    default:
      return produtosCopia;
  }
};

// Função para ordenar variações
export const ordenarVariacoes = (
  variacoes: Variacao[],
  ordenacao: OrdenacaoVariacao
): Variacao[] => {
  if (!ordenacao || !variacoes) return variacoes || [];

  const variacoesCopia = [...variacoes];

  switch (ordenacao) {
    case 'variacao-asc':
      return variacoesCopia.sort((a, b) =>
        (a.variacao ?? '').localeCompare(b.variacao ?? '')
      );
    case 'variacao-desc':
      return variacoesCopia.sort((a, b) =>
        (b.variacao ?? '').localeCompare(a.variacao ?? '')
      );
    case 'preco-desc':
      return variacoesCopia.sort((a, b) => (b.total ?? 0) - (a.total ?? 0));
    case 'preco-asc':
      return variacoesCopia.sort((a, b) => (a.total ?? 0) - (b.total ?? 0));
    default:
      return variacoesCopia;
  }
};
